import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import { sortByName } from "../../utils/sortByName";

const getRateCategory = createAsyncThunk("api/rateCategory",async (token) => {
    try {
      const response = await axios.get("/dashboard/rate-category", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const RateCategoryDataSlice = createSlice({
  name: "Nationality",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRateCategory.fulfilled, (state, action) => {
        state.data = sortByName(action.payload);
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getRateCategory.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getRateCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getRateCategory };
export default RateCategoryDataSlice.reducer;
